import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Award } from "lucide-react";

export default function CertificateModal({ certificate, onClose }) {
  if (!certificate) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
        {/* Backdrop */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 bg-slate-900/40 backdrop-blur-md"
        />

        {/* Modal Box */}
        <motion.div
          initial={{ scale: 0.9, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.9, opacity: 0, y: 20 }}
          className="relative w-full max-w-3xl rounded-3xl bg-white border border-slate-200 p-6 sm:p-8 shadow-2xl z-10 space-y-6 overflow-hidden"
        >
          {/* Header */}
          <div className="flex items-center justify-between border-b border-slate-100 pb-4">
            <div className="flex items-center gap-3">
              <div className="p-2.5 rounded-xl bg-amber-50 text-amber-700 border border-amber-200">
                <Award size={20} />
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900">{certificate.name}</h3>
                <p className="text-xs text-indigo-600 font-mono font-semibold">{certificate.category}</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-xl bg-slate-100 text-slate-600 hover:text-slate-900 border border-slate-200 transition"
            >
              <X size={18} />
            </button>
          </div>

          {/* Certificate High-Res Image Preview */}
          <div className="relative w-full rounded-2xl overflow-hidden border border-slate-200 bg-slate-50 max-h-[60vh] flex items-center justify-center p-2">
            <img
              src={certificate.src}
              alt={certificate.name}
              className="max-h-[55vh] w-auto object-contain rounded-xl shadow-md"
            />
          </div>

          {/* Footer Action */}
          <div className="flex items-center justify-between pt-2 text-xs font-mono text-slate-500">
            <span>Verified Credentials</span>
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-sans font-semibold text-xs shadow-md"
            >
              Close Preview
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}
